module.exports = __webpack_public_path__ + "static/media/Erin Bradner.6b7c5fc2.png";